export class StatutCode {
  static Success: number = 200;
  static Unauthorized: number = 401;
  static Forbidden: number = 403;
  static BadRequest: number = 400;
  static NotFound: number = 404;
  static InternalServer: number = 500;
  static ServiceUnavailable: number = 503;
  static FrontEnd: number = 0;
}
